export default __webpack_public_path__ + "4fb896dab6c05ad2f4ffd552abd5327a.wav";